<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Edit Product</h4>
          </div>
          <div class="card-content">
            <form method="get" action="/" v-on:submit.prevent class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">&nbsp;</label>
                  <div class="col-sm-10">
                    <img :src="imageUrl" width="140" height="140">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Name</label>
                  <div class="col-sm-10">
                    <input type="text" name="name" v-model="product.data.name" v-validate="modelValidations.name" class="form-control" />
                    <small class="text-danger" v-show="name.invalid">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Size</label>
                  <div class="col-sm-10">
                    <input type="text" name="size" v-model="product.data.size" v-validate="modelValidations.size" class="form-control" />
                    <small class="text-danger" v-show="size.invalid">
                      {{ getError('size') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Color</label>
                  <div class="col-sm-10">
                    <input type="text" name="color" v-model="product.data.color" v-validate="modelValidations.color" class="form-control" />
                    <small class="text-danger" v-show="color.invalid">
                      {{ getError('color') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Style</label>
                  <div class="col-sm-10">
                    <input type="text" name="style" v-model="product.data.style" v-validate="modelValidations.style" class="form-control" />
                    <small class="text-danger" v-show="style.invalid">
                      {{ getError('style') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">SKU</label>
                  <div class="col-sm-10">
                    <input type="text" name="sku" v-model="product.data.sku" v-validate="modelValidations.sku" class="form-control" />
                    <small class="text-danger" v-show="sku.invalid">
                      {{ getError('sku') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">UPC</label>
                  <div class="col-sm-10">
                    <input type="text" name="upc" v-model="product.data.upc" v-validate="modelValidations.upc" class="form-control" />
                    <small class="text-danger" v-show="upc.invalid">
                      {{ getError('upc') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Amazon FNSKUs</label>
                  <div class="col-sm-10">
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com</label>
                      <input type="text" name="amazonComFnsku" v-model="product.data.amazonComFnsku" v-validate="modelValidations.amazonComFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComFnsku.invalid">
                        {{ getError('amazonComFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.ca</label>
                      <input type="text" name="amazonCaFnsku" v-model="product.data.amazonCaFnsku" v-validate="modelValidations.amazonCaFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCaFnsku.invalid">
                        {{ getError('amazonCaFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.mx</label>
                      <input type="text" name="amazonComMxFnsku" v-model="product.data.amazonComMxFnsku" v-validate="modelValidations.amazonComMxFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComMxFnsku.invalid">
                        {{ getError('amazonComMxFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.cn</label>
                      <input type="text" name="amazonCnFnsku" v-model="product.data.amazonCnFnsku" v-validate="modelValidations.amazonCnFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCnFnsku.invalid">
                        {{ getError('amazonCnFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.in</label>
                      <input type="text" name="amazonInFnsku" v-model="product.data.amazonInFnsku" v-validate="modelValidations.amazonInFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonInFnsku.invalid">
                        {{ getError('amazonInFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.co.jp</label>
                      <input type="text" name="amazonCoJpFnsku" v-model="product.data.amazonCoJpFnsku" v-validate="modelValidations.amazonCoJpFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCoJpFnsku.invalid">
                        {{ getError('amazonCoJpFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.sg</label>
                      <input type="text" name="amazonComSgFnsku" v-model="product.data.amazonComSgFnsku" v-validate="modelValidations.amazonComSgFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComSgFnsku.invalid">
                        {{ getError('amazonComSgFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.tr</label>
                      <input type="text" name="amazonComTrFnsku" v-model="product.data.amazonComTrFnsku" v-validate="modelValidations.amazonComTrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComTrFnsku.invalid">
                        {{ getError('amazonComTrFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.ae</label>
                      <input type="text" name="amazonAeFnsku" v-model="product.data.amazonAeFnsku" v-validate="modelValidations.amazonAeFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonAeFnsku.invalid">
                        {{ getError('amazonAeFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.fr</label>
                      <input type="text" name="amazonFrFnsku" v-model="product.data.amazonFrFnsku" v-validate="modelValidations.amazonFrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonFrFnsku.invalid">
                        {{ getError('amazonFrFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.de</label>
                      <input type="text" name="amazonDeFnsku" v-model="product.data.amazonDeFnsku" v-validate="modelValidations.amazonDeFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonDeFnsku.invalid">
                        {{ getError('amazonDeFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.it</label>
                      <input type="text" name="amazonItFnsku" v-model="product.data.amazonItFnsku" v-validate="modelValidations.amazonItFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonItFnsku.invalid">
                        {{ getError('amazonItFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.nl</label>
                      <input type="text" name="amazonNlFnsku" v-model="product.data.amazonNlFnsku" v-validate="modelValidations.amazonNlFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonNlFnsku.invalid">
                        {{ getError('amazonNlFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.es</label>
                      <input type="text" name="amazonEsFnsku" v-model="product.data.amazonEsFnsku" v-validate="modelValidations.amazonEsFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonEsFnsku.invalid">
                        {{ getError('amazonEsFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.co.uk</label>
                      <input type="text" name="amazonCoUkFnsku" v-model="product.data.amazonCoUkFnsku" v-validate="modelValidations.amazonCoUkFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCoUkFnsku.invalid">
                        {{ getError('amazonCoUkFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.au</label>
                      <input type="text" name="amazonComAuFnsku" v-model="product.data.amazonComAuFnsku" v-validate="modelValidations.amazonComAuFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComAuFnsku.invalid">
                        {{ getError('amazonComAuFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.br</label>
                      <input type="text" name="amazonComBrFnsku" v-model="product.data.amazonComBrFnsku" v-validate="modelValidations.amazonComBrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComBrFnsku.invalid">
                        {{ getError('amazonComBrFnsku') }}
                      </small>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    <i v-tooltip="prodLandingUrlTip" class="ti-help" style="font-size: 1em;"></i>
                    Redirect URL
                  </label>
                  <div class="col-sm-10">
                    <input type="text" name="redirectUrl" v-model="product.data.redirectUrl" v-validate="modelValidations.redirectUrl" class="form-control" />
                    <small class="text-danger" v-show="redirectUrl.invalid">
                      {{ getError('redirectUrl') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">New Image</label>
                  <div class="col-sm-10">
                    <input type="file" name="imageFile" ref="imageFile" accept="image/*" @change="selectFile" />
                    <input v-show="false" type="text" name="image" v-validate="modelValidations.image"  class="form-control" />
                    <small class="text-danger" v-show="image.invalid">
                      {{ getError('image') }}
                    </small>
                    <p-progress :value="uploadProgress" type="info"></p-progress>
                  </div>
                </div>
              </fieldset>

              <button type="submit" v-if="!loading" @click.prevent="validateSaveProduct()" class="btn btn-fill btn-info">Save</button>
              <button type="button" v-if="loading" class="btn btn-fill btn-info" disabled="disabled">
                <span class="btn-label">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
                Save
              </button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {Table, TableColumn, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  // var storageRef = firebase.storage().ref()
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch,
      PProgress,
      [Select.name]: Select
    },
    mixins: [toolboxMixin],
    props: ['accountData'],
    computed: {
      ...mapFields(['name',
        'amazonComFnsku',
        'amazonCaFnsku',
        'amazonComMxFnsku',
        'amazonCnFnsku',
        'amazonInFnsku',
        'amazonCoJpFnsku',
        'amazonComSgFnsku',
        'amazonComTrFnsku',
        'amazonAeFnsku',
        'amazonFrFnsku',
        'amazonDeFnsku',
        'amazonItFnsku',
        'amazonNlFnsku',
        'amazonEsFnsku',
        'amazonCoUkFnsku',
        'amazonComAuFnsku',
        'amazonComBrFnsku',
        'image',
        'size',
        'color',
        'style',
        'sku',
        'upc',
        'redirectUrl'])
    },
    data () {
      return {
        user: {
          email: '',
          token: ''
        },
        product: {
          id: '',
          data: {}
        },
        newProduct: {
          image: '',
          name: '',
          brandIndex: ''
        },
        imageFile: '',
        imageUrl: '',
        uploadProgress: 0,
        loading: true,
        prodSlotsRemaining: 2,
        modelValidations: {
          name: {
            required: true
          },
          amazonComFnsku: {
            required: false
          },
          amazonCaFnsku: {
            required: false
          },
          amazonComMxFnsku: {
            required: false
          },
          amazonCnFnsku: {
            required: false
          },
          amazonInFnsku: {
            required: false
          },
          amazonCoJpFnsku: {
            required: false
          },
          amazonComSgFnsku: {
            required: false
          },
          amazonComTrFnsku: {
            required: false
          },
          amazonAeFnsku: {
            required: false
          },
          amazonFrFnsku: {
            required: false
          },
          amazonDeFnsku: {
            required: false
          },
          amazonItFnsku: {
            required: false
          },
          amazonNlFnsku: {
            required: false
          },
          amazonEsFnsku: {
            required: false
          },
          amazonCoUkFnsku: {
            required: false
          },
          amazonComAuFnsku: {
            required: false
          },
          amazonComBrFnsku: {
            required: false
          },
          redirectUrl: {
            required: false,
            url: {
              require_protocol: true
            }
          }
        },
        prodLandingUrlTip: 'If provided, then anyone who submits a registration for this product will be redirected to this URL after submission.'
      }
    },
    methods: {
      init () {
        this.getCurrentUser().then(result => {
          this.user = result
          // this.getBrandsAndProducts()
          console.log('got user from store')
          console.log(this.user)
        })
        this.product.id = this.$route.params.productId
        console.log('productId')
        console.log(this.product.id)
        this.loadProduct(this.product.id)
      },
      selectFile () {
        this.imageFile = this.$refs.imageFile.files[0]
        this.uploadFile()
      },
      uploadFile () {
        this.loading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`brands/${this.product.data.brandId}/products/${filename}`).put(this.imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.uploadProgress = progress
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.loading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(async downloadURL => {
              console.log('File available at', downloadURL)
              this.product.data.imageUrl = downloadURL
              this.imageUrl = await this.prodImgUrl(this.product.id, this.product.data, '140x140')
              this.loading = false
            })
          })
      },
      async loadProduct (productId) {
        let productDoc = await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(productId).get()
        this.product.data = productDoc.data()
        this.imageUrl = await this.prodImgUrl(this.product.id, this.product.data, '140x140')
        this.loading = false
      },
      getBrandsAndProducts () {
        db.collection(`brands`).where('accountId', '==', this.user.accountId).get().then(qs => {
          qs.forEach(doc => {
            let brand = doc.data()
            brand.id = doc.id
            this.brands.push(brand)
            this.getBrandProducts(brand.id, brand.name)
          })
        })
      },
      validateSaveProduct () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveProduct()
          } else {
            this.loading = false
          }
        })
      },
      async saveProduct () {
        await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(this.product.id).update(this.product.data)
        this.showNotify('Product saved.', 'success', 'Success')
        this.loading = false
        this.$router.replace({ name: 'Products' })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      getSummaries (param) {
        const { columns } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.productsTable.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.fnsku-label {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Product.vue